import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";


const firebaseConfig = {
  apiKey: "AIzaSyCUL_ich2GK-Xvw-oWQuHtvKHvYtjBdFfw",
  authDomain: "smartpmhub-app.firebaseapp.com",
  projectId: "smartpmhub-app",
  storageBucket: "smartpmhub-app.firebasestorage.app",
  messagingSenderId: "538330916630",
  appId: "1:538330916630:web:e9f505eab47252d3ea1237"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);


